type ObserveVisibilityAndTrigger = {
  element: HTMLElement;
  callback?: () => void;
  rootMargin?: `${number}px` | number;
};

export const fromNumerOrPxToRootMargin = (rootMargin: `${number}px` | number): string => {
  if (typeof rootMargin === 'number') {
    return `${rootMargin}px`;
  }
  if (typeof rootMargin === 'string') {
    return rootMargin.endsWith('px') ? rootMargin : `${rootMargin}px`;
  }
  return '0px';
};

export function observeVisibilityAndTrigger({ element, rootMargin = '40px', callback }: ObserveVisibilityAndTrigger) {
  let hasLoaded = false;
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        // Start loading when the component is within 10% of being visible (rootMargin)
        if (!hasLoaded && entry.intersectionRatio > 0) {
          hasLoaded = true;
          observer.disconnect(); // stop observing after first trigger
          callback();
        }
      });
    },
    {
      root: null, // use the viewport as the root
      threshold: 0, // trigger as soon as any part is in the rootMargin
      rootMargin: fromNumerOrPxToRootMargin(rootMargin), // start loading when 20px away from being visible
    },
  );
  observer.observe(element);
}
